var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessToast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58565",
    "data-name": "Group 58565",
    transform: "translate(20428 15590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7791",
    "data-name": "Rectangle 7791",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(-20428 -15590)",
    fill: "#3ebe63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M23.7,12.129A11.567,11.567,0,1,1,12.129.562,11.567,11.567,0,0,1,23.7,12.129Zm-12.9,6.125,8.582-8.582a.746.746,0,0,0,0-1.055L18.318,7.561a.746.746,0,0,0-1.055,0l-7,7L7,11.293a.746.746,0,0,0-1.055,0L4.885,12.348a.746.746,0,0,0,0,1.055l4.851,4.851a.746.746,0,0,0,1.055,0Z",
    transform: "translate(-20415.563 -15577.563)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToast);
export default __webpack_public_path__ + "static/media/success_toast.2a1c4d65f2d6652590c919a6de041e74.svg";
export { ForwardRef as ReactComponent };